import { Grid } from "@mui/material"
import { Link } from "@mui/material"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const Navbar = () => {

    return(
        <div className="navbar-wrapper">
            <Grid 
                className="dropdown-menu-wrapper" >
                <Link 
                    href="https://mutual.app/" 
                    className="menu-button"
                > 
                    Mutual 
                    <KeyboardArrowDownIcon/> 
                </Link>

                <Grid 
                    className="dropdown-menu-mutual dropdown-menu-md"
                    container
                    justifyContent='flex-end'
                >
                    <a className="a-border-line" href="/premium/">MutualUp</a>
                    <a className="a-border-line" href="https://mutual.app/standards">Community Standards</a>
                    <a className="a-border-line" href="https://mutual.app/terms">Terms of Service</a>
                    <a href="https://mutual.app/privacy">Privacy Policy</a>
                </Grid>
            </Grid >

            <Grid 
                className="dropdown-menu-wrapper" >
                <Link 
                    href="https://mutual.app/" 
                    className="menu-button"
                > 
                    MutualDates
                    <KeyboardArrowDownIcon/> 
                </Link>

                <Grid 
                    className="dropdown-menu-mutual dropdown-menu-xl"
                    container
                >
                    <a className="a-border-line" href="https://mutual.app/datesterms">Mutual Dates Terms of Sale</a>
                    <a href="https://mutual.app/datespartnerterms">Mutual Dates Partner Terms of Use</a>
                </Grid>
            </Grid >

            <Grid className="dropdown-menu-wrapper">
                <Link href="https://support.mutual.app/" className="menu-button">Support</Link>
            </Grid >

            <Grid className="dropdown-menu-wrapper">
                <Link href="https://mutual.app/careers" className="menu-button">Careers</Link>
            </Grid >

            <Grid className="dropdown-menu-wrapper">
                <Link href="https://blog.mutual.app/" className="menu-button">Blog</Link>
            </Grid >
        </div>
    )
}


export default Navbar